import { render, staticRenderFns } from "./TheAttachment.vue?vue&type=template&id=8d009332&scoped=true&"
import script from "./TheAttachment.vue?vue&type=script&lang=js&"
export * from "./TheAttachment.vue?vue&type=script&lang=js&"
import style0 from "./TheAttachment.vue?vue&type=style&index=0&id=8d009332&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d009332",
  null
  
)

export default component.exports